import styled from 'styled-components';
import { ReactSelectOptionLabel } from 'types/TagRefDefinition';

export const Button = styled.button<ReactSelectOptionLabel>`
  background: none;
  color: inherit;
  border: none;
  width: 100%;
  text-align: left;
  padding: 0;
  padding-left: ${({ padding }) => padding}rem;
`;

export const Label = styled.label`
  font-size: 12px;
  color: #333333;
  margin-left: 2px;
`;

export const ReactSelectLabel = styled.label`
  position: absolute;
  font-size: 12px;
  color: #333333;
  margin-left: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* overflow: hidden; */
  /* white-space: nowrap; */
  /* width: 250px; */
`;
export const CheckboxContainer = styled.input`
  margin-right: 11px;
  .regularCheckbox {
    -webkit-appearance: none;
    background-color: #fafafa;
    border: 1px solid #8795a2;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    padding: 9px;
    border-radius: 3px;
    display: inline-block;
    position: relative;
    background: #ffffff;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
  }

  .regularCheckbox:hover {
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    border: 1px solid rgba(0, 118, 191, 1) !important;
  }

  .regularCheckbox:active,
  .regularCheckbox:checked:active {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px 1px 3px rgba(0, 0, 0, 0.1);
    width: 16px;
    height: 16px;
    border: 1px solid #ffffff !important;
  }

  .regularCheckbox:checked:after {
    position: absolute;
    top: 4px !important;
    right: 6px !important;
    content: '';
    display: block;
    width: 9px;
    height: 4px;
    border-bottom: 2px solid #ffffff;
    border-left: 2px solid #ffffff;
    transform: rotate(-45deg) scale(1);
  }

  .regularCheckbox:checked {
    background-color: #e9ecee;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
      inset 15px 10px -12px rgba(255, 255, 255, 0.1);
    color: rgba(0, 118, 191, 1);
    background-color: rgba(0, 118, 191, 1);
    position: relative;
    border: 1px solid #ffffff;
    width: 16px;
    height: 16px;
  }

  .intermediateCheckbox:after {
    position: absolute;
    top: 6px !important;
    left: 2px;
    content: '';
    width: 10px;
    border-bottom: 2px solid #ffffff;
    border-left: 2px solid #ffffff;
    border-bottom: 2px solid rgba(0, 118, 191, 1);
    border-left: 2px solid rgba(0, 118, 191, 1);
  }

  .intermediateCheckbox {
    background-color: #e9ecee;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
      inset 15px 10px -12px rgba(255, 255, 255, 0.1);
    color: rgba(0, 118, 191, 1);
    background-color: rgba(0, 118, 191, 1);
    position: relative;
    border: 1px solid #ffffff;
    width: 16px;
    height: 16px;
    background-color: white;
    border: 1px solid #8795a2;
  }

  .bigCheckbox {
    padding: 18px;
  }

  .bigCheckbox:checked:after {
    font-size: 28px;
    left: 3px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-family: Roboto;
  position: relative;
`;

export const DropDownContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 8px 0;
  width: 247px;
  position: relative;
`;

export const RefreshContainer = styled.div`
  margin: 72px 0 0 8px;
  font-size: 12px;
  color: #8795a1;
`;

export const InputWrapper = styled.span`
  width: 247px;
  height: 30px;
  border: 1px solid #d1d1d1;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 12px;
  justify-content: space-between;
  color: #949494;
`;

export const InputDropDown = styled.input`
  border: none;
  width: 100%;
  outline: none;
  color: #949494;
`;
